import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "placeholder"]
  static values = { src: String }

  connect() {
    this.loaded = false
    this.load()
  }

  retry() {
    if (this.loaded) return
    this.element.classList.remove("comment-card__image--error")
    this.element.classList.add("comment-card__image--loading")
    this.load()
  }

  load() {
    this.element.classList.add("comment-card__image--loading")
    const img = this.imageTarget
    img.onload = () => {
      this.loaded = true
      this.element.classList.remove("comment-card__image--loading")
      this.element.classList.add("comment-card__image--loaded")
    }
    img.onerror = () => {
      this.element.classList.remove("comment-card__image--loading")
      this.element.classList.add("comment-card__image--error")
    }
    img.src = this.srcValue
  }
}
